<div class="overflow-wrapper">
    <div class="what-is-heading upcoming">
        <div class="content-wrapper">
            <div class="illustration-text-wrapper">
                <h2>{{ 'APPOINTMENT-OVERVIEW.UPCOMING.WHAT-IS' | translate}}</h2>
                <p>{{ 'APPOINTMENT-OVERVIEW.UPCOMING.WHAT-IS-DESCRIPTION' | translate}}</p>
            </div>
        </div>
        <img class="header-illustration" src="/assets/img/illustrations/upcoming.png" alt="">
    </div>
</div>
<ng-container *ngIf="{upcoming: upcomingAppointments$ | async, isInit: isInit$ | async} as appointments">
    <div class="appointment-info-wrapper" *ngIf="appointments?.upcoming?.length > 0">
        <app-appointment-info
            *ngFor="let appointment of appointments?.upcoming"
            [appointment]="appointment"
            [appointmentInfoType]="upcomingAppointmentInfoType">
        </app-appointment-info>
    </div>
    <div *ngIf="!appointments?.upcoming?.length && !appointments.isInit"
        class="content-wrapper empty-appointments appointment-overview-wrapper">
        <h3 class="no-appointment-message">{{ 'APPOINTMENT-OVERVIEW.UPCOMING.EMPTY-APPOINTMENTS' | translate }}</h3>
    </div>
</ng-container>
